import { Box, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

export const FILTER_ALL_ORDERS = "all orders";
export const FILTER_DUE_SOON = "due soon";
export const FILTER_PAST_DUE = "past due";

const ORDER_FILTERS = [
  FILTER_ALL_ORDERS,
  FILTER_DUE_SOON,
  FILTER_PAST_DUE
] as const;

export const FilterRow = ({
  currentSelectedFilter,
  handleFilterChange
}: {
  currentSelectedFilter: string;
  handleFilterChange: (filter: string) => void;
}) => {
  const { t } = useTranslation();

  const selectedIndex = ORDER_FILTERS.findIndex(
    (filter) => filter === currentSelectedFilter
  );
  const defaultedIndex = selectedIndex >= 0 ? selectedIndex : 0;
  return (
    <Stack direction="row" gap={1} width="100%">
      <Box
        sx={{
          backgroundColor: "gray.light",
          borderRadius: 1,
          padding: 0.5,
          width: "100%",
          position: "relative"
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: 4,
            left: `calc(${(defaultedIndex / ORDER_FILTERS.length) * 100}% + 4px)`,
            width: `calc(${100 / ORDER_FILTERS.length}% - 8px)`,
            height: 40,
            backgroundColor: "white",
            borderRadius: 1,
            boxShadow: "0 2px 6px 0 rgba(0, 0, 0, 0.16)",
            transition: "left 0.25s cubic-bezier(0.4, 0, 0.2, 1)",
            zIndex: 0
          }}
        />
        <Stack
          direction="row"
          justifyContent="space-between"
          sx={{ position: "relative", zIndex: 1 }}
        >
          {ORDER_FILTERS.map((filter) => {
            const isSelected = currentSelectedFilter === filter;
            return (
              <button
                key={filter}
                onClick={() => handleFilterChange(filter)}
                style={{
                  backgroundColor: "transparent",
                  borderRadius: 8,
                  border: "none",
                  width: "100%",
                  height: "40px",
                  cursor: "pointer"
                }}
              >
                <Typography
                  variant="body2"
                  color={isSelected ? "textPrimary" : "textSecondary"}
                  sx={{
                    transition: "color 0.2s eased"
                  }}
                >
                  {t(filter)}
                </Typography>
              </button>
            );
          })}
        </Stack>
      </Box>
    </Stack>
  );
};
